import React from 'react';
import { useTranslation } from 'react-i18next';
import CostCenterOptionLabel from '../../../../../documentostributarios/costCenters/CostCenterOptionLabel';
import { formatMoneyWithCurrency } from '../../../../../../utils/formatter';
import './EntryLineCostCenters.scss';

const EntryLineCostCenters = ({
  costCenters = [],
  displayCurrency = 'CLP',
  classNamePrefix = 'entry',
}) => {
  const { t } = useTranslation('accounting');

  if (!costCenters.length) return null;

  const label = t('journalEntry.costCenters');

  return (
    <div className="entry-cost-centers-rows" aria-label={label}>
      <div className={`${classNamePrefix}-accounts-row entry-cost-centers-label-row`}>
        <div className="entry-cost-centers-label">{label}</div>
      </div>
      {costCenters.map((cc) => {
        const formatted = formatMoneyWithCurrency(
          cc.amount,
          cc.currency || displayCurrency,
        );
        return (
          <div
            key={cc.key}
            className={`${classNamePrefix}-accounts-row entry-cost-centers-row`}
          >
            <div role="cell">
              <CostCenterOptionLabel
                name={cc.label}
                icon={cc.icon}
                color={cc.color}
                filledIcon
                vivid
              />
            </div>
            <div role="cell" className="entry-amount">
              {cc.side === 'debit' ? formatted : ''}
            </div>
            <div role="cell" className="entry-amount">
              {cc.side === 'credit' ? formatted : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EntryLineCostCenters;
